module.exports = __webpack_public_path__ + "img/traumgaben.ef43c662.png";